import { RESOLUTION_OPTIONS, ResolutionValueType } from 'constants/chart'
import {
  InterveItemrBox,
  IntervalBox,
  HeaderContainer,
  HeaderRight,
  HeaderLeft,
  StyledIcon,
  StyledRightIcon,
} from './styles'
import { useResolution } from 'store/orderbook/hooks'
import { useDispatch } from 'react-redux'
import { updateResolution } from 'store/orderbook/actions'
import ChartTypeSelector from './ChartTypeSelector'
import { ReactComponent as IndicatorIcon } from './assets/indicators.svg'
import { ReactComponent as PropertyIcon } from './assets/property.svg'
import { ReactComponent as FullIcon } from './assets/full.svg'
import { ReactComponent as ScreenShotIcon } from './assets/screenshot.svg'
import dayjs from 'dayjs'
import { useCurrentSymbol } from 'store/market/hooks'
import { IntervalSelector } from './IntervalSelector'
import { useFavoriteResolution } from 'store/orderbook/hooks'
import useWindow from 'hooks/useWindow'

const TVHeader = () => {
  const resolution = useResolution()
  const dispatch = useDispatch()
  const symbol = useCurrentSymbol()
  const _favorites = useFavoriteResolution()
  const { isMobile } = useWindow()

  return (
    <HeaderContainer>
      <HeaderLeft>
        <IntervalBox>
          {_favorites.map((item, i) => {
            return (
              <InterveItemrBox
                key={i}
                className={
                  RESOLUTION_OPTIONS[item as ResolutionValueType] === resolution
                    ? 'active'
                    : ''
                }
                onClick={() => {
                  dispatch(
                    updateResolution(
                      RESOLUTION_OPTIONS[item as ResolutionValueType],
                    ),
                  )
                  try {
                    window.tvWidget
                      .activeChart()
                      .setResolution(
                        RESOLUTION_OPTIONS[item as ResolutionValueType],
                      )
                  } catch (error) {}
                }}
              >
                {item}
              </InterveItemrBox>
            )
          })}
        </IntervalBox>
        {!isMobile && (
          <>
            <IntervalSelector />
            <ChartTypeSelector />
            <StyledIcon
              style={{ marginLeft: '4px' }}
              onClick={() => {
                window.tvWidget
                  .activeChart()
                  .executeActionById('insertIndicator')
              }}
            >
              <IndicatorIcon />
              Indicators
            </StyledIcon>
          </>
        )}
      </HeaderLeft>

      {!isMobile && (
        <HeaderRight>
          <StyledRightIcon
            onClick={() => {
              window.tvWidget.activeChart().executeActionById('chartProperties')
            }}
          >
            <PropertyIcon />
          </StyledRightIcon>
          <StyledRightIcon
            onClick={() => {
              const canvas = document.getElementById('tv_chart_container')!
              if (canvas.requestFullscreen) {
                canvas.requestFullscreen()
              }
            }}
          >
            <FullIcon />
          </StyledRightIcon>
          <StyledRightIcon
            onClick={() => {
              window.tvWidget.takeClientScreenshot().then((canvas: any) => {
                const imgUrl = canvas.toDataURL('image/jpeg')
                const aDom = document.createElement('a')
                aDom.href = imgUrl
                aDom.download = `ZKEX_${symbol?.baseCurrency}_${symbol?.quoteCurrency}_${dayjs().format(
                  'YYYY-MM-DD_HH-mm-ss',
                )}.png`
                aDom.click()
              })
            }}
          >
            <ScreenShotIcon />
          </StyledRightIcon>
        </HeaderRight>
      )}
    </HeaderContainer>
  )
}

export default TVHeader
